export default {
  namespaced: true,
  presets_ptz: {
    title: "preset | presets",
    id_camera: "Câmera id",
    presets: "presets",
  },
};
